/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.span`
  color: rgba(0, 0, 0, 0.85);
  font-size: ${scale.minor(5)}px;
  font-weight: 600;
`;
